export default "__VITE_ASSET__Cx1DKcdV__"